import type {ValueType} from '@github-ui/custom-properties-types'
import {FilterProviderType, type SuppliedFilterProviderOptions} from '@github-ui/filter'
import {StaticFilterProvider} from '@github-ui/filter/providers'
import {NoteIcon} from '@primer/octicons-react'

import {BOOLEAN_FILTER_VALUES} from './static'

export interface PropertyDefinition {
  propertyName: string
  allowedValues?: string[] | null
  required?: boolean
  valueType: ValueType
}

export function getCustomPropertiesProviders(definitions: PropertyDefinition[], canUseNone: boolean) {
  return definitions.map(definition => new CustomPropertyFilterProvider(definition, canUseNone))
}

const singleSelect: SuppliedFilterProviderOptions = {filterTypes: {multiKey: false, multiValue: true, valueless: false}}
const multiSelect: SuppliedFilterProviderOptions = {filterTypes: {multiKey: true, multiValue: true, valueless: false}}

const NOT_SHOWN = 10

class CustomPropertyFilterProvider extends StaticFilterProvider {
  constructor({propertyName, allowedValues, required, valueType}: PropertyDefinition, canUseNone: boolean) {
    allowedValues ||= []
    const filter = {
      displayName: `Property: ${propertyName}`,
      key: `props.${propertyName}`,
      priority: NOT_SHOWN,
      icon: NoteIcon,
    }

    const values = allowedValues.map((value, index) => ({value, displayName: value, priority: index + 1}))

    if (!required && canUseNone) {
      values.unshift({value: 'none', displayName: 'None', priority: 1})
    }

    const filterValues = valueType === 'boolean' ? BOOLEAN_FILTER_VALUES : values
    const filterOptions = valueType === 'multi_select' ? multiSelect : singleSelect

    super(filter, filterValues, filterOptions)

    this.type = this.filterProviderType(valueType)
  }

  filterProviderType = (valueType: ValueType) => {
    switch (valueType) {
      case 'single_select':
        return FilterProviderType.Select
      case 'multi_select':
        return FilterProviderType.Select
      case 'boolean':
        return FilterProviderType.Boolean
      case 'string':
        return FilterProviderType.Text
    }
  }
}
